import { render, staticRenderFns } from "./DeleteTestDialog.vue?vue&type=template&id=7a24ed1c&scoped=true"
import script from "./DeleteTestDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteTestDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a24ed1c",
  null
  
)

export default component.exports